<div class="w-full h-screen pt-8 pb-20 px-4 bg-linear-(--my-gradient8) relative overflow-hidden">
    <p class="text-[#584102] font-medium text-base sm:text-lg xl:text-3xl capitalize text-center">Access Denied — This Gem is Locked</p>
    <div>
        <div class="text-c19725 text-6xl sm:text-8xl lg:text-9xl xl:text-[300px] flex items-center justify-center mt-4 lg:mt-10 mb-8 ">4
            <div class="relative">
                    <img class="size-16 sm:size-20 lg:size-30 xl:size-68" src="/assets/images/error/diamond3.png" alt="Forbidden">
            </div>
            3
        </div>

        <p class="text-444 text-sm/normal sm:text-base/normal xl:text-3xl/normal font-normal text-center">You don’t have permission to view this page</p>
        <p class="text-444 text-sm/normal sm:text-base/normal xl:text-3xl/normal font-bold text-center"> Some sections are like rare jewels — only for authorized users</p>

    </div>
</div>